import { useState } from 'react';
import {
  Button, TextField, Grid2 as Grid, Typography, FormControl,
  Select, MenuItem, IconButton
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import PropTypes from 'prop-types';

import { isEmpty } from '../../components/common/helpers';
import { checkUser, getCode } from '../../actions/users';

const FormForgetPass2 = ({
  type, data, setData, setPasos
}) => {
  const [disabled, setDisabled] = useState(false);
  const [error, setError] = useState({
    tel: '',
    email: ''
  });

  const continuar = async e => {
    e.preventDefault();

    if (data.email == '' && type === 'email') {
      return setError({
        email: 'Campo requerido'
      });
    }

    if (data.tel == '' && type === 'celular') {
      return setError({
        tel: 'Campo requerido'
      });
    }
    const info = {
      email: data.email,
      tel: "52".concat(data.tel),
    }

    const resCheck = !isEmpty(data.email) ? await checkUser(data.email) : await checkUser(data.tel);
    console.log(resCheck.error)
    if (!resCheck.error) {
      setDisabled(true);
      info.nombre = resCheck.name;
      const result = await getCode(type, info, "olvido");
      if (!isEmpty(result)) {
        await setData({
          ...data,
          userId: resCheck._id
        })
        setPasos(3);
      }
    } else {
      setError({
        email: resCheck.msg,
      })
    }
  }

  const cambiar = e => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const typeValidation = type == 'email'
    ? 'la dirección de correo electrónico'
    : ' el número de teléfono'

  return (
    <form noValidate onSubmit={continuar}>
      <Grid size={12}>
        <IconButton
          className="btn-icon"
          aria-label="back"
          onClick={() => setPasos(1)}
        >
          <ChevronLeftIcon />
        </IconButton>
      </Grid>
      <Grid container spacing={2} sx={{ my: 3 }}>
        <Grid className="step1-forgot" container direction="column">
          <Typography variant="h3" component="h3">¿Olvidaste tu contraseña?</Typography>
          <Typography component="p">
            Introduce {typeValidation} vinculado a tu cuenta.
          </Typography>
        </Grid>
        {
          type == "email"
            ? <Grid size={{ xs: 8, lg: 8 }}>
              <TextField
                className="input-sigup"
                error={isEmpty(error.email) ? false : true}
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                value={data.email}
                onChange={cambiar}
                helperText={!isEmpty(error.email) && error.email}
              />
            </Grid>
            : <>
              <Grid size={{ xs: 3, sm: 4 }}>
                <FormControl sx={{ width: "100%" }}>
                  <Select
                    autoWidth
                    name="prefijo"
                    className="input-sigup"
                    value={data.prefijo}
                    onChange={cambiar}
                    IconComponent={() => <ArrowDropDownCircleIcon color="primary" />}
                  >
                    <MenuItem value="52"><img alt="México" width="20" src="/mexico.png" /> +52</MenuItem>
                    <MenuItem value="1"><img alt="EEUU" width="20" src="/eeuu.png" /> +1</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 9, sm: 8, md: 6 }}>
                <TextField
                  error={!isEmpty(error.tel) ? true : false}
                  variant="outlined"
                  required
                  fullWidth
                  id="tel"
                  label="Teléfono"
                  name="tel"
                  value={data.tel}
                  onChange={cambiar}
                  helperText={!isEmpty(error.tel) && error.tel}
                />
              </Grid>
            </>
        }
      </Grid>
      <Grid size={{ xs: 8, lg: 6 }}>
        <Button fullWidth
          variant="contained"
          color="primary"
          type="submit"
          disabled={disabled}
        >
          Enviar código
        </Button>
      </Grid>
    </form>
  )
}

FormForgetPass2.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  setData: PropTypes.func.isRequired,
  setPasos: PropTypes.func.isRequired
}

export default FormForgetPass2;
